import type { EventGroup as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type EventGroup = {
  id: number;
  name: string;
};

export const fromGql = (item: GQLItem): EventGroup => take<EventGroup>(item, 'id', 'name');
